import React, { lazy, Suspense, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import MESSAGES from '../../../constants/Messages'
import PaginatorComponent from '../../Pagination/PaginatorComponent'
const BookingDetailListMobile = lazy(() =>
    import('./BookingDetailListMobile.js')
)

const rowCount = 10
const recordsPerRequest = 30
const initialPageNumber = 1

const BookingListMain = ({
    getBookingDetails,
    bookingSearchFormData,
    listBookingResponse,
    listBookingError,
    setNotificationMessage,
    setNotificationType,
    initialSearch,
    setInitialSearch,
    isLoading,
    setIsLoading,
}) => {
    //FOR MULTILINGUAL
    const [t] = useTranslation(['labels', 'errors'])
    const [bookingList, setBookingList] = useState([])
    const [totalRecordCount, setTotalRecordCount] = useState(0)
    const [pageIndex, setPageIndex] = useState(1)
    const [currentPage, setCurrentPage] = useState(0)
    const [startIndex, setStartIndex] = useState(0)
    const [endIndex, setEndIndex] = useState(0)
    const [calculatedPageNumber, setCalculatedPageNumber] = useState(1)

    useEffect(() => {
        if (listBookingResponse) {
            setBookingList(listBookingResponse.bookingList)
            setTotalRecordCount(listBookingResponse.totalRecordCount)
            let modulusOfPageIndex = pageIndex % (recordsPerRequest / rowCount)
            if (modulusOfPageIndex === 0) {
                modulusOfPageIndex = 3
                setStartIndex((modulusOfPageIndex - 1) * rowCount)
                setEndIndex(modulusOfPageIndex * rowCount)
            } else {
                setStartIndex((modulusOfPageIndex - 1) * rowCount)
                setEndIndex(modulusOfPageIndex * rowCount)
            }
        }
    }, [listBookingResponse, pageIndex])

    useEffect(() => {
        if (initialSearch) {
            setPageIndex(1)
            setCurrentPage(0)
        }
    }, [initialSearch])

    useEffect(() => {
        if (calculatedPageNumber >= initialPageNumber) {
            getBookingDetails(bookingSearchFormData, calculatedPageNumber, null)
        }
    }, [calculatedPageNumber])

    const onPageIndexChange = (newPageIndex, currentPageToDisplay) => {
        setPageIndex(newPageIndex)
        setCurrentPage(currentPageToDisplay)
        setInitialSearch(false)
        const calculatedPageNumber = Math.ceil(
            (newPageIndex * rowCount) / recordsPerRequest
        )
        setCalculatedPageNumber(calculatedPageNumber)
    }

    return (
        <div id='BookingDetailsList' className='mt-3 mt-lg-5 mb-3'>
            <div className='form-row'>
                <div className='col-12'>
                    <h3 className='page-sub-head'> {t('COMMON.BOOKING LIST')}</h3>
                </div>
            </div>

            {listBookingResponse && totalRecordCount > 0 && (
                <div className='form-row mb-4 booking-details__total-results-display'>
                    <div className='col-12 d-flex justify-content-between align-items-center'>
						<div className='booking-details-count'>
							{totalRecordCount}
							{''} {totalRecordCount > 1 ? t('COMMON.BOOKINGS') : ''}
							{totalRecordCount === 1 && t('COMMON.BKG_HEAD')}
						</div>
						<div className='page-details-text'>
							{t('COMMON.SHOWING')} {bookingList.slice(startIndex, endIndex).length} {t('COMMON.OF')} {totalRecordCount}
						</div>
					</div>
                </div>
            )}

            {listBookingResponse && bookingList.length === 0 && (
                <div className='no-data ml-0 mr-0'>
                    {' '}
                    {t(MESSAGES.NO_BOOKINGS, { ns: 'errors' })}
                </div>
            )}

            {!listBookingResponse &&
                !listBookingError &&
                (initialSearch || initialSearch == null) && (
                    <div className='no-data m-0'>
                        {t(MESSAGES.LOADING, { ns: 'errors' })}
                    </div>
                )}

            {listBookingError && (
                <div className='no-data m-0'>
                    {t(MESSAGES.PROCESS_REQUEST_FAILED, { ns: 'errors' })}
                </div>
            )}

            {/* Render paginated booking list */}
            {listBookingResponse &&
                bookingList.length >= 1 &&
                bookingList.slice(startIndex, endIndex).map((result, index) => (
                    <Suspense fallback={<></>} key={result?.id || index}>
                        {result && (
                            <BookingDetailListMobile
                                index={index}
                                result={result}
                                setNotificationMessage={setNotificationMessage}
                                setNotificationType={setNotificationType}
                            />
                        )}
                    </Suspense>
                ))}

            {/* Paginator */}
            {listBookingResponse && bookingList.length !== 0 && (
                <div className='paginationWrapper'>
                    <PaginatorComponent
                        initialSearch={initialSearch}
                        currentPage={currentPage}
                        pageIndex={pageIndex}
                        rowCount={rowCount}
                        totalRecords={totalRecordCount}
                        onPageIndexChange={onPageIndexChange}
                    />
                </div>
            )}
        </div>
    )
}

export default BookingListMain